import { render, staticRenderFns } from "./CoAccessPolicyList.vue?vue&type=template&id=6793f1d6&scoped=true&"
import script from "./CoAccessPolicyList.vue?vue&type=script&lang=js&"
export * from "./CoAccessPolicyList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=6793f1d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6793f1d6",
  null
  
)

export default component.exports